import { makeStyles } from '@material-ui/core';
import { FC, useEffect, useState } from 'react';
import Draggable from 'react-draggable';

import {
  DIALOG_RED_BODY,
  FLOATER_BLUE_BACKGROUND,
  MODAL_BORDER_RADIUS,
  MODAL_BOX_SHADOW,
} from '../../../../../problem/src/modals/constants';
import { postToggleClock } from '../../../studentApp/api';
import { bannerStore } from '../../../studentApp/stores';
import { timeStuckStore } from '../../../studentApp/stores/timeStuckStore';
import { DraggableTop } from '../util/constants';

interface StyleProps {
  isCollapsed: boolean;
  minutes: number;
}

const useStyles = makeStyles({
  clockHandle: {
    position: 'fixed',
    top: 0,
    left: '50%',
    backgroundColor: (props: StyleProps) =>
      props.minutes > 5 ? DIALOG_RED_BODY : FLOATER_BLUE_BACKGROUND,
    width: '150px',
    height: (props: StyleProps) => (props.isCollapsed ? '25px' : '65px'),
    borderRadius: MODAL_BORDER_RADIUS,
    boxShadow: MODAL_BOX_SHADOW,
  },
  messageBody: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    padding: '10px',
    color: 'white',
  },
});

export const Clock: FC = () => {
  const setShowClock = bannerStore(state => state.setShowClock);
  const minutes = timeStuckStore(state => Math.floor(state.timeStuck / 60000));
  const [isCollapsed, setIsCollapsed] = useState(false);

  const classes = useStyles({ isCollapsed, minutes });

  const [minimizedMessage, setMinimizedMessage] = useState('');
  const [message, setMessage] = useState('');

  const close = (): void => {
    setShowClock(false);
    postToggleClock({ showClock: false });
  };

  useEffect(() => {
    if (minutes === 0) {
      setMinimizedMessage('< 1 min.');
      setMessage('< 1 minute');
    } else if (minutes === 1) {
      setMinimizedMessage('1 min.');
      setMessage('1 minute');
    } else {
      setMinimizedMessage(minutes + ' mins.');
      setMessage(minutes + ' minutes');
    }
  }, [minutes, setMessage, setMinimizedMessage]);

  return (
    <Draggable handle=".gmm-clock-handle">
      <div className={classes.clockHandle}>
        <DraggableTop
          backgroundColor={
            minutes > 5 ? DIALOG_RED_BODY : FLOATER_BLUE_BACKGROUND
          }
          close={close}
          isCollapsed={isCollapsed}
          minimizedMessage={minimizedMessage}
          toggleCollapse={() => setIsCollapsed(!isCollapsed)}
          dragHandle="gmm-clock-handle"
        />

        {!isCollapsed && <div className={classes.messageBody}>{message}</div>}
      </div>
    </Draggable>
  );
};
